import React from "react";
import { ID } from "common/entities/IEntity";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockView } from "common/views/block/BlockView.view";
import { BoxVariant, BoxView } from "common/views/box/Box.view";
import HeadingView from "common/views/heading/Heading.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import { nDef } from "core/util/TypeUtils";
import { PARAM_USER_ID } from "panels/organizationAdmin/UserList.panel";
import { Config } from "./Config";
import { Organization } from "./entities/Organization";
import { User } from "./entities/User";


interface IUserQueryArgs {
	id: ID;
}

const UserQuery = Query.queryOne<User, IUserQueryArgs>(User);
const OrganizationQuery = Query.queryMany<Organization, {}>(Organization);

@Panel({id: "user-profile", configClass: Config, pageParams: true})
export default class UserProfile extends React.Component<IPanelProps<Config>> {

	public render() {
		const { config, pageParams } = this.props;

		if (nDef(pageParams[PARAM_USER_ID])) {
			return (
				<NonIdealState title="Select a User" description="Please select a user to see profile details" />
			);
		}

		return (
			<BlockView viewKey="profile">
				<UserQuery params={{id: pageParams[PARAM_USER_ID]}}>
					{({data, loading}) => {
						if (loading) {
							return <Loading />;
						}

						if (!data) {
							return <NonIdealState title="User Not Found" description="" />;
						}

						return (
							<BlockView viewKey="user">
								<HeadingView viewKey="name" children={data.firstName + ' ' + data.lastName} />
								<HeadingView viewKey="email" children={data.email} />
							</BlockView>
						);
					}}
				</UserQuery>
				{
					config.showOrganizations && (
						<OrganizationQuery params={{}}>
							{({data, loading}) => {
								if (loading) {
									return <Loading />;
								}

								if (isEmpty(data)) {
									return <NonIdealState title="No Organizations Found" description="User is not a part of any organizations you have access to." />;
								}

								return (
									<BoxView title="Organizations" variant={BoxVariant.MINIMAL} viewKey="organizations">
										{data.map(this.renderOrganization)}
									</BoxView>
								);
							}}
						</OrganizationQuery>
					)
				}
			</BlockView>
		);
	}

	private renderOrganization = (org: Organization) => (
		<HeadingView viewKey="organization" key={org.id} children={org.name} />
	)
}



// WEBPACK FOOTER //
// ./src/panels/userProfile/UserProfile.panel.tsx